import * as React from 'preact/compat'
import cn from 'classnames'
import SVG from '../SVG'
import buttonsCss from '../../../css/buttons.pcss.json'
import formCss from '../../../css/form.pcss.json'
import styles from '../../../css/game-editor.pcss.json'
import { loadStylesheet, showModal } from '../../common/helpers'
import type { TargetedEvent } from 'preact/compat'
import { getCurrentScheme } from '../../plugins/color-scheme'
import GameCoverEditorModal from './GameCoverEditorModal'

interface PropTypes {
  covers: {
    square_poster: string,
    large_poster: string
  },
  steamId?: string,
  gameName?: string,
  oldLogo?: string,
  hideLabels?: boolean
}

interface StateTypes {
  square_poster: string,
  square_poster_files?: FileList,
  large_poster: string,
  large_poster_files?: FileList,
}

const setBroken = (fallbackSrc: string) => {
  const onError = (event: TargetedEvent<HTMLImageElement>) => {
    const theme: 'dark'|'light' = getCurrentScheme()
    event.currentTarget.src = `/img/backdrop-${fallbackSrc}-${theme}.png`;
    event.currentTarget.removeEventListener('error', onError)
  }
  return onError
}

export default class GameCoversEditor extends React.Component<PropTypes, StateTypes> {

  state: StateTypes = {
    square_poster: this.props.covers.square_poster,
    large_poster: this.props.covers.large_poster,
  }

  squareFileInput = React.createRef<HTMLInputElement>()
  largeFileInput = React.createRef<HTMLInputElement>()

  componentWillMount() {
    loadStylesheet('form')
    loadStylesheet('game-editor');
  }

  componentDidUpdate(previousProps: Readonly<PropTypes>, previousState: Readonly<StateTypes>) {
    if (this.props.covers !== previousProps.covers) {
      this.setState({
        square_poster: this.props.covers.square_poster,
        large_poster: this.props.covers.large_poster,
      })
      return
    }
    if (this.state.square_poster_files !== previousState.square_poster_files && this.squareFileInput.current) {
      this.squareFileInput.current.files = this.state.square_poster_files
    }
    if (this.state.large_poster_files !== previousState.large_poster_files && this.largeFileInput.current) {
      this.largeFileInput.current.files = this.state.large_poster_files
    }
  }

  showSquareModal = () => {
    showModal(GameCoverEditorModal, {
      src: this.state.square_poster,
      modalType: 'square',
      updateImage: (src: string, files: FileList) => {
        this.setState({
          square_poster: src,
          square_poster_files: files
        })
      },
      steamId: this.props.steamId,
      gameName: this.props.gameName,
      oldLogo: this.props.oldLogo
    })
  }

  showLargeModal = () => {
    showModal(GameCoverEditorModal, {
      src: this.state.large_poster,
      modalType: 'large',
      updateImage: (src: string, files: FileList) => {
        this.setState({
          large_poster: src,
          large_poster_files: files
        })
      },
      steamId: this.props.steamId,
      gameName: this.props.gameName,
      oldLogo: this.props.oldLogo
    })
  }

  render() {
    const {
      square_poster,
      square_poster_files,
      large_poster,
      large_poster_files,
    } = this.state

    const square_poster_img = square_poster || ''
    const large_poster_img = large_poster || ''

    return <div className={styles['covers-editor']}>
      <div className={styles['covers-editor__image']}>
        {!this.props.hideLabels && <label className={formCss['label']}>
          Обложка игры<br/>
          <span className={formCss['error-hint']} style='margin-top:0'>(с названием)</span>
        </label>}
        {!square_poster_files && <input type='hidden' name='square_poster' value={square_poster} />}
        {square_poster_files && <input type='file' style='display: none' name='square_poster' ref={this.squareFileInput} />}
        <img className={styles['covers-editor__image--square']} src={square_poster_img} alt='' onError={setBroken('square')} />
        <button className={cn(buttonsCss['button--icon'], buttonsCss['on-image'], styles['on-image'])} type='button' onClick={this.showSquareModal}>
          <SVG i='sg-new/edit' adaptive />
        </button>
      </div>
      <div className={cn(styles['covers-editor__image'], styles['covers-editor__image--large-container'])}>
        {!this.props.hideLabels && <label className={formCss['label']}>
          Шапка на странице игры<br/>
          <span className={formCss['error-hint']} style='margin-top:0'>(без названий и логотипов)</span>
        </label>}
        {!large_poster_files && <input type='hidden' name='large_poster' value={large_poster} />}
        {large_poster_files && <input type='file' style='display: none' name='large_poster' ref={this.largeFileInput} />}
        <img className={styles['covers-editor__image--large']} src={large_poster_img} alt='' onError={setBroken('large')} />
        <button className={cn(buttonsCss['button--icon'], buttonsCss['on-image'], styles['on-image'])} type='button' onClick={this.showLargeModal}>
          <SVG i='sg-new/edit' adaptive />
        </button>
      </div>
    </div>
  }
}
